import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { trackPageview } from '@xingternal/hops-tracking';
import { useExperimentTrackingData } from '@xingternal/hub';

import {
  useFormSettingsTrackingData,
  useIsPrioritizedJob,
  useJobPostingRevenueType,
  useUpdateFormPageviewTracking,
} from '@/domain/job-application/contexts';
import { useCrateFormExperiment, useLoginStates } from '@/hooks';

export function useTrackApplyFormPageview(): void {
  const [isPageViewTracked, setIsPageViewTracked] = useState<boolean>(false);
  const updateFormPageviewTracking = useUpdateFormPageviewTracking();
  const postingRevenueType = useJobPostingRevenueType();
  const formSettingsTrackingProp = useFormSettingsTrackingData();
  const { isLoggedIn } = useLoginStates();
  const isPaidJob = useIsPrioritizedJob();
  const { isExperimentEnabled } = useCrateFormExperiment(isPaidJob);
  const experimentTrackingData = useExperimentTrackingData();

  useEffect(() => {
    if (!isPageViewTracked) {
      trackPageview(
        'wbm/Stellenmarkt/apply/start',
        {},
        {
          PropFormList: 'jobs_apply_form_open',
          PropJobsApplyId: uuidv4(),
          PropContextDimension2: postingRevenueType,
          PropContextDimension4: `jobs_apply_${formSettingsTrackingProp}`,
          ...(isLoggedIn || !isExperimentEnabled ? {} : experimentTrackingData),
        }
      );
      setIsPageViewTracked(true);
      updateFormPageviewTracking();
    }
  }, [
    isPageViewTracked,
    updateFormPageviewTracking,
    postingRevenueType,
    formSettingsTrackingProp,
    isLoggedIn,
    isExperimentEnabled,
    experimentTrackingData,
  ]);
}
